import { PaymentMethod } from "../../../../../../../../Wrap/Constants/Enums/Domain/PaymentMethod";
import { AllowedPaymentMethodModel } from "../../../../../../../../Wrap/Models/Models/Pension/Payments/AllowedPaymentMethodModel";

export function GetAllowedMethodsIgnoreAmountSetting(allowedPaymentMethods: AllowedPaymentMethodModel[]): PaymentMethod[] {
    return allowedPaymentMethods?.map(m => m.PaymentMethod)?.filter((method, index, arr) => 
        arr.findIndex(item => item?.toString() === method?.toString()) === index
    ) || [];
}

export function ExcludeNonSelectiveMethod(allowedPaymentMethods: AllowedPaymentMethodModel[]): AllowedPaymentMethodModel[] {
    //InternalTransfer: auto selected when choose cash account
    //Swift: auto selected when choose non-gbp bankAccount, for such case, method is displayed as Swift but disabled instead of hide
    const nonBankAccountSupportedMethods = [PaymentMethod.InternalTransfer];
    return allowedPaymentMethods?.filter(pm => !nonBankAccountSupportedMethods.includes(pm.PaymentMethod)) || [];
}

export function GetAllowedMethods(allowedPaymentMethods: AllowedPaymentMethodModel[], paymentAmount: number | undefined, hasInternationalBankAccountDestination: boolean): PaymentMethod[] {
    var newAllowedPaymentMethods: AllowedPaymentMethodModel[]=[];
    allowedPaymentMethods.forEach(element => {
        if (element.PaymentMethod == PaymentMethod.Swift && !hasInternationalBankAccountDestination) {
            return;
        }
        newAllowedPaymentMethods.push(element)
    });

    if (paymentAmount === undefined ){
        return GetAllowedMethodsIgnoreAmountSetting(newAllowedPaymentMethods);
    }

    return newAllowedPaymentMethods?.filter(pm => (pm.LowerLimit == undefined || pm.LowerLimit <= paymentAmount) && (pm.UpperLimit == undefined || pm.UpperLimit >= paymentAmount))?.map(y => y?.PaymentMethod) || [];
}

export function GetDefaultMethodIgnoreAmountSetting(allowedPaymentMethods: AllowedPaymentMethodModel[]): PaymentMethod {
    return allowedPaymentMethods?.filter(pm => pm?.IsDefault)?.[0]?.PaymentMethod || PaymentMethod.NotSpecified;
}

export function GetDefaultMethod(allowedPaymentMethods: AllowedPaymentMethodModel[], paymentAmount: number|undefined): PaymentMethod {
    if (paymentAmount === undefined ){
        return GetDefaultMethodIgnoreAmountSetting(allowedPaymentMethods);
    }
    
    return allowedPaymentMethods?.filter(pm => pm?.IsDefault && (pm.LowerLimit == undefined || pm.LowerLimit <= paymentAmount) && (pm.UpperLimit == undefined || pm.UpperLimit >= paymentAmount))?.[0]?.PaymentMethod || PaymentMethod.NotSpecified;
}
